import React, {useEffect, useId, useRef} from "react";
import {Tooltip} from "primereact/tooltip";

interface InfoLabelProps {
    children: string;
    htmlFor?: string | undefined;
    info?: string | undefined;
}

export default function InfoLabel({children, htmlFor, info}: InfoLabelProps) {
    const genId = useId();
    const id = genId.replaceAll(':', '')

    return <>
        <label htmlFor={htmlFor} style={{fontWeight: "600"}}>{children}</label>
        { info &&
            <>
                <Tooltip target={`#${id}`} autoHide={false} />
                <i id={id} className="info-label-icon pi pi-info-circle" data-pr-tooltip={info} data-pr-position="right" data-pr-at="right+10 top+5"  style={{paddingLeft: "0.25rem", cursor: 'pointer' }}/>
            </>
        }
    </>
}